export const wpData = async (content) => {
  try {
    const url = `https://keidge.com/wp/wp-json/wp/v2/${content}`;
    const response = await fetch(url);
    const data = await response.json();
    // console.log("API data: " + data);
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};
